import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/nouveautes", label: "Nouveautés" },
  { to: "/actualites", label: "Actualités" },
  { to: "/livres", label: "Livres" },
  { to: "/auteurs", label: "Nos Auteurs" },
  { to: "/gazette", label: "Gazette" },
  { to: "/lectures-recommandees", label: "Lectures recommandées" },
  { to: "/soumission", label: "Soumission" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FAF9F6]/90 border-b border-[#D1CFC7]/50"
          : "bg-transparent"
      }`}
    >
      <nav className="px-6 md:px-12 lg:px-24 py-3 flex items-center justify-between">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-4 md:gap-5 group"
        >
          <img
            src="/cled-logo.jpg"
            alt="CLED — Challenges Littéraires Éditions"
            className="h-16 sm:h-20 md:h-24 w-auto object-contain mix-blend-multiply transition-transform duration-500 group-hover:scale-[1.03]"
          />
          <div
            data-testid="brand-wordmark"
            className="hidden md:flex flex-col leading-tight border-l border-[#2C402E]/30 pl-4 lg:pl-5 py-1"
          >
            <span className="font-serif text-base lg:text-lg text-[#1A1A1A] tracking-[0.18em] uppercase">
              Challenges <span className="text-[#2C402E]">Littéraires</span>
            </span>
            <span className="font-serif text-base lg:text-lg text-[#9E4735] tracking-[0.32em] uppercase mt-1">
              Éditions
            </span>
          </div>
        </Link>

        {/* Desktop nav */}
        <ul className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                end={link.to === "/"}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `text-sm tracking-wide font-body link-underline transition-colors ${
                    isActive ? "text-[#2C402E] font-medium" : "text-[#4A4A4A] hover:text-[#1A1A1A]"
                  }`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <button
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-[#1A1A1A]"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#FAF9F6] border-t border-[#D1CFC7]/50 px-6 py-6"
        >
          <ul className="flex flex-col gap-5">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <NavLink
                  to={link.to}
                  end={link.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                  className={({ isActive }) =>
                    `block text-base font-body ${
                      isActive ? "text-[#2C402E] font-medium" : "text-[#4A4A4A]"
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};
